module.exports = __webpack_public_path__ + "static/media/Apple_App_store.0d50bee6.svg";